/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import {safeJSONParse} from './JSONUtils';

/**
 * Provides a general utility which encodes a value to a base-64 encoded string.
 * If the value can not be decoded, the value is simply returned.
 *
 * ```typescript
 *
 *   import {encode} from '@ion/core/src/utils'
 *
 *   const password = decode(persisted.password);
 *
 * ```
 */
export const encode = (val: any): any => {
  try {
    return window?.btoa(JSON.stringify(val));
  } catch (err) {
    return val;
  }
};

/**
 * Provides a general utility which decodes a base-64 encoded string. If the
 * string can not be decoded, the value is simply returned.
 *
 * ```typescript
 *
 *   import {decode} from '@ion/core/src/utils'
 *
 *   const password = decode(persisted.password);
 *
 * ```
 */
export const decode = val => {
  const result = safeJSONParse(window?.atob(val));
  return result || val;
};
